// Iter-f9 — Canonical tooltip strings for every Overview-dashboard
// summary card, branch metric, and chart card. Centralised so the
// three dashboards and their drill-down pages read from a single
// source of truth — change the wording here and it propagates
// everywhere automatically.

export const CANCELLATION_TIPS = {
  clients: "Unique client × date. If the same client cancels on two different days it counts as 2. If they cancel a service and a package on the same day it counts as 1.",
  appointments: "Each single-treatment cancellation counts as 1. Each package cancellation counts as 1 regardless of how many treatments are inside the package.",
  packages: "1 per cancelled package, regardless of the number of treatments inside.",
};

export const SERVICE_PERFORMANCE_TIPS = {
  treatments: "Each single treatment counts as 1 per client per visit regardless of quantity on the order line. Packages count as 1 treatment per client per visit.",
};

export const STAFF_UTILISATION_TIPS = {
  utilisation: "Booked hours (service time + processing time for completed appointments) divided by available roster hours at this branch, multiplied by 100.",
  clients: "Unique clients seen by this staff member in the selected period.",
  treatments: "1 per client per visit, same rule as Service Performance.",
};
